<script>
  export let pageName;
</script>

<section class="breadcrumbs-custom">
  <div class="breadcrumbs-custom-main context-dark" />
  <div class="breadcrumbs-custom-aside">
    <div class="container">
      <ul class="breadcrumbs-custom-path">
        <li class="active">{[pageName]}</li>
      </ul>
    </div>
  </div>
</section>
